import { CompanyProvider } from "./companies"

const ContextProvider = ({ children }) => {
    return (
        <CompanyProvider>
            {children}
        </CompanyProvider>
    )
}

export default ContextProvider;